import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { UI_FILTER } from '@bwoty-web/ui-kit/icons';
import { useIsGlobetrotter, useIsMobile } from '@bwoty-web/ui-kit/hooks';
import { bindActionCreators } from 'redux';
import { Button, FilterFooter, Icon, PopoutMenu } from '@bwoty-web/ui-kit';

import FilterGroup from './FilterGroup';
import {
  filterActiveSelector,
  filterMatchesSelector,
} from '../../../redux/selectors/cruiseList/filterSelectors';

import * as CruiseListActions from '../../../redux/actions/cruiseListActions';

import './cruiseFilterPanel.scss';

const CruiseFilterPanel = ({
  actions,
  filterActive,
  filterGroups,
  filterMatches,
  filterPanelIsVisible,
  labels,
}) => {
  const isGlobe = useIsGlobetrotter();
  const isMobile = useIsMobile();
  const filterGroupsMarkup = Object.values(filterGroups)
    .map((filterGroup) => {
      const {
        heading,
        id,
        maxNumberOfDestinations: maxDest,
        maxValue,
        minNumberOfDestinations: minDest,
        minValue,
        options,
        order,
        selected,
        selectedMaxNumberOfDestinations: selectedMaxDest,
        selectedMinNumberOfDestinations: selectedMinDest,
      } = filterGroup;

      const minMaxSame =
        minValue != null && maxValue != null && minValue === maxValue;
      let hasLessThanTwoOptions = !options || options?.length < 2;
      if (options === undefined && !minMaxSame) hasLessThanTwoOptions = false;
      if (hasLessThanTwoOptions || minMaxSame) return null;

      let amountOfActiveFilters = selected?.length;
      if (amountOfActiveFilters === undefined)
        amountOfActiveFilters = filterActive[id] ? 1 : 0;
      if (
        id === 'destination' &&
        filterActive[id] &&
        selectedMinDest &&
        selectedMaxDest &&
        (selectedMinDest !== minDest || selectedMaxDest !== maxDest)
      )
        amountOfActiveFilters += 1;

      const filterTitle = `${heading}${
        amountOfActiveFilters > 0 ? ` (${amountOfActiveFilters})` : ''
      }`;

      return {
        id,
        title: filterTitle,
        content: (
          <FilterGroup
            filterActions={actions}
            filterGroup={filterGroup}
            filterMatches={filterMatches}
            filterPanelIsOpen={filterPanelIsVisible}
            filterStopsAllLabel={labels.filter_stops_all}
            key={order}
          />
        ),
      };
    })
    .filter((f) => !!f)
    .sort((a, b) => a.key - b.key);

  const anyFilterActive = Object.values(filterActive).some(
    (isActive) => isActive === true,
  );

  const footerContent = (
    <FilterFooter
      onClearFilter={actions.clearFilters}
      onShowTrip={() => actions.toggleFilterPanel(false)}
      disableClearFilter={!anyFilterActive}
    />
  );

  const numberOfActiveFilters = Object.values(filterActive).filter(
    (isActive) => isActive === true,
  ).length;

  const filterBtnElement = document.getElementById(
    'iw-cruise-list__filter-button',
  );

  const filterBtnProps = { ...(isMobile && { 'aria-haspopup': 'dialog' }) };
  return (
    <div className="iw-cruise-list__filter-container">
      <Button
        className="iw-cruise-list__filter-btn"
        id="iw-cruise-list__filter-button"
        onClick={() => actions.toggleFilterPanel(!filterPanelIsVisible)}
        variant={isGlobe ? 'secondary' : 'secondary-dark'}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...filterBtnProps}
      >
        <Icon size="xs" sizeMobile="xs" alt="" path={UI_FILTER} />
        {`${labels.filterBtnLabel}${
          numberOfActiveFilters > 0 ? ` (${numberOfActiveFilters})` : ''
        }`}
      </Button>
      <PopoutMenu
        className="iw-cruise-filter-popout-menu"
        drawerHeight={60}
        footerContent={footerContent}
        menuItems={filterGroupsMarkup}
        onClose={() => actions.toggleFilterPanel(false)}
        show={filterPanelIsVisible}
        title={labels.filterHeading}
        triggerElements={[filterBtnElement]}
      />
    </div>
  );
};

const mapActions = (dispatch) => {
  return {
    actions: bindActionCreators({ ...CruiseListActions }, dispatch),
  };
};

const mapStateToProps = (state) => {
  const newState = state.toJS();
  return {
    filterActive: filterActiveSelector(newState),
    filterGroups: newState.filter.filterGroups,
    filterMatches: filterMatchesSelector(newState),
    filterPanelIsVisible: newState.filter.filterPanelIsVisible,
    labels: newState.labels,
  };
};

CruiseFilterPanel.propTypes = {
  actions: PropTypes.shape({
    clearFilters: PropTypes.func.isRequired,
    toggleFilterPanel: PropTypes.func.isRequired,
  }).isRequired,
  filterActive: PropTypes.shape({}).isRequired,
  filterGroups: PropTypes.shape({}).isRequired,
  filterMatches: PropTypes.shape({}).isRequired,
  filterPanelIsVisible: PropTypes.bool.isRequired,
  labels: PropTypes.shape({
    filter_stops_all: PropTypes.string.isRequired,
    filterBtnLabel: PropTypes.string.isRequired,
    filterHeading: PropTypes.string.isRequired,
  }).isRequired,
};

export default connect(mapStateToProps, mapActions)(CruiseFilterPanel);
